import { useEffect, useState } from "react";

/**
 * M06, the resend clock: after a send the button turns quiet and counts down
 * from 1:00 in place (once a second, no animation on the digits); at zero it
 * is a button again.
 */
export function useResendClock(seconds = 60) {
  const [until, setUntil] = useState<number | null>(null);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!until) return;
    const id = window.setInterval(() => {
      const t = Date.now();
      setNow(t);
      if (t >= until) setUntil(null);
    }, 1000);
    return () => window.clearInterval(id);
  }, [until]);

  const left = until ? Math.max(0, Math.ceil((until - now) / 1000)) : 0;
  return {
    waiting: left > 0,
    /** "0:42" */
    label: `${Math.floor(left / 60)}:${String(left % 60).padStart(2, "0")}`,
    start: () => {
      const t = Date.now();
      setNow(t);
      setUntil(t + seconds * 1000);
    },
  };
}

/** "14:32", the time a resend went, in the device's clock. */
export function clockTime(date = new Date()): string {
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });
}
